import axios from 'axios';
import config from '../api.config.json';

export default class API {
    constructor(token) {
        const headers = {
            'content-type': 'application/json',
            Accept: '*/*',
            'PZCRM-APPID': '1824661064992263'
        };

        if (token) headers['Authorization'] = `Bearer ${token}`;

        let url;
        switch (window.location.origin) {
            /* UAT */
            case config.uat_domain:
                url = config.uat_api_base_url;
                break;
            /* Live Prod */
            case config.prod_domain:
                url = config.prod_api_base_url;
                // headers["PZCRM-APPID"] = "2974926922875468";
                break;
            /* DEV */
            default:
                url = config.uat_api_base_url;
                break;
        }

        this.api = axios.create({
            baseURL: url,
            headers,
            // Restrict the request time => throw err if exceeds 5s
            timeout: 5000
        });
        // interceptor => like a checkpoint for every http action
        // request inerceptor: e.g. attach token to every request
        // response interceptor: e.g. parse api response
        /* Change 'content-type' when calling uploadMedia */
        this.api.interceptors.request.use((request) => {
            if (
                request.url.includes('reset-password') ||
                request.url === 'voucher/use-multiple' ||
                request.url.includes('details') ||
                request.url.includes('add-metadata') ||
                request.url.includes('update-metadata')
            ) {
                request.headers['content-type'] = 'multipart/form-data';
                return request;
            } else return request;
        });
        this.api.interceptors.response.use(
            function (response) {
                return parseData(response);
            },
            function (error) {
                console.log('error', error);
                return Promise.reject(error);
            }
        );

        const parseData = (res) => {
            if (res.status === 200) {
                console.log(res.data);
                return res.data;
            } else {
                return Promise.reject(res.data);
            }
        };
    }
    getAccessToken(locationCode, phoneNum, pwd) {
        const url = 'auth/login-with-mobile-password';
        const formData = new FormData();
        const form = {
            mobile_phone_prefix: locationCode,
            mobile_phone: phoneNum,
            password: pwd,
            logout_other_sessions: 1 // make sure only 1 user login to the a/c
        };
        Object.keys(form).forEach((key) => {
            formData.append(key, form[key]);
        });
        const res = this.api.post(url, formData);
        return res;
    }

    forgetPasswordOTP(locationCode, phoneNum) {
        const url = 'auth/forgot-password-with-mobile';
        const formData = new FormData();
        const form = {
            mobile_phone_prefix: locationCode,
            mobile_phone: phoneNum,
            logout_other_sessions: 1,
            lang: 'tc'
        };
        Object.keys(form).forEach((key) => {
            formData.append(key, form[key]);
        });
        const res = this.api.post(url, formData);
        return res;
    }

    CheckOtpStatus(locationCode, phoneNum, otp) {
        const url = 'auth/reset-password-token-status-with-mobile';
        const formData = new FormData();
        const form = {
            mobile_phone_prefix: locationCode,
            mobile_phone: phoneNum,
            token: otp
        };
        Object.keys(form).forEach((key) => {
            formData.append(key, form[key]);
        });
        const res = this.api.post(url, form);
        return res;
    }
    resetPassword(locationCode, phoneNum, otp, newPwd) {
        const url = 'auth/reset-password-with-mobile';
        const formData = new FormData();
        const form = {
            mobile_phone_prefix: locationCode,
            mobile_phone: phoneNum,
            token: otp,
            new_password: newPwd
        };
        Object.keys(form).forEach((key) => {
            formData.append(key, form[key]);
        });
        const res = this.api.post(url, formData);
        return res;
    }

    getMerchantInfo() {
        const url = 'user/profile';
        const res = this.api.get(url);
        return res;
    }

    changePassword(pwd, newPwd) {
        const url = 'user/change-password';
        const formData = new FormData();
        const form = {
            old_password: pwd,
            new_password: newPwd
        };
        Object.keys(form).forEach((key) => {
            formData.append(key, form[key]);
        });
        const res = this.api.post(url, formData);
        return res;
    }

    queryOneTimeCode(codes) {
        const url = `voucher/one-time-voucher`;
        const formData = new FormData();
        const form = {
            code: codes
        };
        Object.keys(form).forEach((key) => {
            formData.append(key, form[key]);
        });
        const res = this.api.post(url, formData);
        return res;
    }

    queryVoucher(codes) {
        const url = 'voucher/info';
        const param = JSON.stringify({ voucher_codes: [codes] });
        const res = this.api.post(url, param);
        return res;
    }

    getScanErrCount() {
        const url = 'statistics/scan-error';
        const res = this.api.get(url);
        return res;
    }

    // getCustomerOTP(customer_id) {
    //   const url = `customer/${customer_id}/mobile-otp-request`;
    //   const res = this.api.get(url);
    //   return res;
    // }

    redeemVoucher(newRecord) {
        const url = 'voucher/use-multiple';
        const formData = new FormData();
        let form = {
            spending_amount: newRecord.spending_amount,
            operator_remarks: newRecord.remarks,
            reference_id: newRecord.reference_id
        };
        newRecord.vouchers.map((code) => {
            if (!form.hasOwnProperty('voucher_codes[]')) {
                Object.assign(form, { 'voucher_codes[]': [code] });
            } else form['voucher_codes[]'].push(code);
        });
        newRecord.oneTimeRef.map((ref) => {
            Object.assign(form, { 'onetime_voucher_reference_ids[]': ref });
        });
        Object.assign(form, { 'metadata[receipt_no][]': newRecord.receipt });

        //handle receipt media
        // if (receipts?.length > 0) {
        //     receipts.forEach((receipt, index) => {
        //         form[`receipt${index}_id`] = receipt.media_id;
        //         form[`receipt${index}_token`] = receipt.token;
        //     });
        // }

        // if (receipts?.length > 0) {
        //     receipts.map((receipt, index) => {
        //         if (!form.hasOwnProperty('receipt[]')) {
        //             Object.assign(form, { 'receipt[]': [receipt] });
        //         } else form['receipt[]'].push(receipt);
        //     });
        // }
        Object.keys(form).forEach((key) => {
            formData.append(key, form[key]);
        });
        const res = this.api.post(url, form);
        return res;
    }

    // queryRedeemHistory() {
    //   const url = "redemption/record";
    //   const res = this.api.get(url);
    //   return res;
    // }

    queryRedeemHistoryByDate(queryDate) {
        const url = `voucher-use-history/?date-range=${queryDate}&output=json&view=summary`;
        const res = this.api.get(url);
        return res;
    }

    updateRedeemInfo(redemption_id, expenses, remarks) {
        const url = `voucher-use-history/${redemption_id}/details`;
        const formData = new FormData();
        const form = {
            spending_amount: expenses,
            operator_remarks: remarks
        };
        Object.keys(form).forEach((key) => {
            formData.append(key, form[key]);
        });
        const res = this.api.post(url, form);
        return res;
    }

    addMetadataToVoucher(voucherUseHistoryID, dataKey, dataVal) {
        const url = `voucher-use-history/${voucherUseHistoryID}/add-metadata`;
        const formData = new FormData();
        const form = {
            name: dataKey,
            value: dataVal
        };
        Object.keys(form).forEach((key) => {
            formData.append(key, form[key]);
        });
        const res = this.api.post(url, formData);
        return res;
    }

    updateVoucherMetaData(voucherUseHistoryID, metadataId, newVal) {
        const url = `voucher-use-history/${voucherUseHistoryID}/update-metadata`;
        const formData = new FormData();
        const form = {
            metadata_id: metadataId,
            value: newVal
        };
        Object.keys(form).forEach((key) => {
            formData.append(key, form[key]);
        });
        const res = this.api.post(url, formData);
        return res;
    }

    updateVoucherAttachment(voucherUseHistoryID, media_token) {
        const url = `voucher-use-history/${voucherUseHistoryID}/add-attachment`;
        const formData = new FormData();
        const form = {
            media_token: media_token
            // value: newVal
        };
        Object.keys(form).forEach((key) => {
            formData.append(key, form[key]);
        });
        const res = this.api.post(url, formData);
        return res;
    }

    userLogout() {
        const url = 'user/logout';
        const res = this.api.post(url);
        return res;
    }

    uploadMedia(customer_id, image) {
        const url = `media/`;
        const formData = new FormData();
        const form = {
            file: image,
            customer_id: customer_id
        };
        Object.keys(form).forEach((key) => {
            formData.append(key, form[key]);
        });
        const res = this.api.post(url, formData);
        return res;
    }
}
